import React, { Component } from "react";

import {
  Box,
  Paper,
  Typography,
  Grid,
  Hidden,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio
} from "@material-ui/core";

import { makeStyles, } from "@material-ui/core/styles";

import appearance from "../../services/appearance";

import { get } from "lodash";

import TeamRow from "../TeamRow";
import PickRow from "../PickRow";

const loserFontColor = "#999";

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    "&.MuiFormControlLabel-root": {
      width: "100%",
    },
    "& .MuiFormControlLabel-label": {
      flexGrow: 1,
    },
  },
  inProgressClock: {
    fontSize: "12px",
    marginLeft: theme.spacing(0.5),
    color: appearance.colors.gray.import[600],
  },
}));

const Game = (props) => {
  const classes = useStyles();
  const {
    bracketLinesClassName,
    game,
    pick,
    team1,
    team2,
    team1Picked,
    team2Picked,
    team1PickedId,
    team2PickedId,
    isFirstRound,
    isFirstFour,
    handleAnswerChange,
    firstFourPick,
    disabled,
  } = props;

  const {
    id,
    team1Id,
    team2Id,
    team1Score,
    team2Score,
    isComplete,
    isUpset,
    isLocked,
    startTime,
    round,
    clock,
    period,
  } = game;

  const startTimeDate = startTime ? (startTime.toDate ? startTime.toDate() : new Date(startTime)) : null;

  const {
    winner: pickedWinnerId,
  } = pick;

  const actualWinnerId = !isComplete || (team1Score === 0 && team2Score === 0) ? undefined : team1Score > team2Score ? team1Id : team2Id;
  const firstFourDisabled = isLocked || disabled;

  if (isFirstRound) {
    return (
      <Paper>
        <Box p={1} display="flex" alignItems="center">
          <Box flexGrow={1}>
            <TeamRow
              team={team1}
              score={team1Score}
              isWinner={actualWinnerId === team1Id}
              isPickedToWin={pickedWinnerId === team1Id}
              isUpset={isUpset}
              isComplete={isComplete}
              round={round}
              isFirstRound
            />
            <TeamRow
              team={team2}
              score={team2Score}
              isWinner={actualWinnerId === team2Id}
              isPickedToWin={pickedWinnerId === team2Id}
              isUpset={isUpset}
              isComplete={isComplete}
              round={round}
              isFirstRound
            />
          </Box>
          {!isComplete && period && (clock || period === "FINAL" || period === "HALFTIME") && (
            <Box style={{flexShrink: 0, marginLeft: 2, display: 'inline-block'}}>
              <Typography className={classes.inProgressClock}>{period === "HALFTIME" ? "HALF" : period}</Typography>
              {period !== "FINAL" && period !== "HALFTIME" && <Typography className={classes.inProgressClock}>{clock}</Typography>}
            </Box>
          )}
        </Box>
      </Paper>
    );
  }
  else if (isFirstFour) {
    return (
      <Paper>
        <Box
          py={1}
          pl={1}
          pr={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <FormControl component="fieldset" disabled={firstFourDisabled}>
            <RadioGroup
              aria-label="prediction-question"
              defaultValue={""}
              value={firstFourPick || ""}
              name="radio-buttons-group"
              onChange={(event) => handleAnswerChange(id, event.target.value)}
            >
            <Box
              display="flex"
              justifyContent="space-between"
            >
              <FormControlLabel
                className={classes.formControlLabel}
                key={team1Id}
                value={team1Id}
                control={<Radio size="small" />}
                labelPlacement="start"
                disabled={firstFourDisabled}
                label={
                  <Box flexGrow="1">
                    <TeamRow
                      team={team1}
                      score={team1Score}
                      isWinner={actualWinnerId === team1Id}
                      isPickedToWin={pickedWinnerId === team1Id}
                      isUpset={isUpset}
                      isComplete={isComplete}
                      round={round}
                      isFirstFour
                    />
                  </Box>
                }
              />
            </Box>
          <Box
            display="flex"
            justifyContent="space-between"
          >
              <FormControlLabel
                className={classes.formControlLabel}
                key={team2Id}
                value={team2Id}
                control={<Radio size="small" />}
                labelPlacement="start"
                disabled={firstFourDisabled}
                label={
                  <Box flexGrow="1">
                    <TeamRow
                      team={team2}
                      score={team2Score}
                      isWinner={actualWinnerId === team2Id}
                      isPickedToWin={pickedWinnerId === team2Id}
                      isUpset={isUpset}
                      isComplete={isComplete}
                      round={round}
                      isFirstFour
                    />
                  </Box>
                }
              />
          </Box>
                    </RadioGroup>
          </FormControl>
          <Box ml={1.5}>
            {startTimeDate && !isLocked && !isComplete && (
              <>
                <Typography variant="subtitle2">
                  {startTimeDate.toLocaleDateString([], { month: 'short', day: 'numeric' })}
                </Typography>
                <Typography variant="subtitle2">
                  {startTimeDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
                </Typography>
              </>
            )}
            {!isComplete && period && (clock || period === "FINAL" || period === "HALFTIME") && (
              <Box>
                <Typography className={classes.inProgressClock}>{period === "HALFTIME" ? "HALF" : period}</Typography>
                {period !== "FINAL" && period !== "HALFTIME" && <Typography className={classes.inProgressClock}>{clock}</Typography>}
              </Box>
            )}
          </Box>
        </Box>
      </Paper>
    );
  }
  else {
    return (
      <Paper
        className={bracketLinesClassName}
      >
        <PickRow
          team={team1Picked}
          isWinner={actualWinnerId === team1PickedId}
          isPickedToWin={pickedWinnerId === team1PickedId}
          isComplete={isComplete}
          isInGame={team1PickedId === team1Id}
        />
        <Box px={1} py={0.5} display="flex" alignItems="center">
          <Box flexGrow={1}>
            <TeamRow
              team={team1}
              score={team1Score}
              isWinner={actualWinnerId === team1Id}
              isPickedToWin={pickedWinnerId === team1Id}
              isComplete={isComplete}
              isUpset={isUpset}
              round={round}
            />
            <TeamRow
              team={team2}
              score={team2Score}
              isWinner={actualWinnerId === team2Id}
              isPickedToWin={pickedWinnerId === team2Id}
              isComplete={isComplete}
              isUpset={isUpset}
              round={round}
            />
          </Box>
          {!isComplete && period && (clock || period === "FINAL" || period === "HALFTIME") && (
            <Box style={{flexShrink: 0, marginLeft: 2, display: 'inline-block'}}>
              <Typography className={classes.inProgressClock}>{period === "HALFTIME" ? "HALF" : period}</Typography>
              {period !== "FINAL" && period !== "HALFTIME" && <Typography className={classes.inProgressClock}>{clock}</Typography>}
            </Box>
          )}
        </Box>
        <PickRow
          team={team2Picked}
          isWinner={actualWinnerId === team2PickedId}
          isPickedToWin={pickedWinnerId === team2PickedId}
          isComplete={isComplete}
          isInGame={team2PickedId === team2Id}
        />
      </Paper>
    );
  }
}; 

export default Game;
